var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paragraph",style:({fontSize: _vm.props.fontSize + 'px', ..._vm.props.styles, display: 'block'}),domProps:{"innerHTML":_vm._s(_vm.props.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }